import ClipboardJS from 'clipboard';

const setScrollBarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.body.clientWidth;
	document.documentElement.style.setProperty('--scrollbarWidth', `${scrollbarWidth}px`);
};

const clickToCopy = () => {
	const clipboard = new ClipboardJS('.click-to-copy');
	clipboard.on('success', (e) => {
		const trigger = e.trigger as HTMLElement;
		const buttonText = trigger.querySelector('span');
		const copyText = trigger.dataset.copyText ?? 'Link Copied!';
		const originalText = trigger.dataset.originalText ?? 'Copy Link';
		if (buttonText) {
			buttonText.textContent = copyText;
			setTimeout(() => {
				buttonText.textContent = originalText;
			}, 5000);
		}
	});
};

/**
 * Wrapper function for querySelectorAll to ensure that elements run after convert changes.
 *
 * @param  target   The target to query.
 * @param  callback The callback to run on the elements.
 * @param  multiple Whether to return multiple elements.
 */
const convertQuerySelector = (
	target: string,
	callback: (elements: Element[]) => void,
	multiple = false
): void => {
	const seen = new Set<Element>();

	const run = () => {
		// Get all matching elements.
		let matches: Element[] = [];
		if (multiple) {
			matches = Array.from(document.querySelectorAll<HTMLElement>(target));
		} else {
			const singleMatch = document.querySelector(target);
			if (null !== singleMatch) {
				matches = [singleMatch];
			}
		}

		// Filter out elements that have already been seen and run the callback.
		const fresh = matches.filter((el) => !seen.has(el));
		if (fresh.length > 0) {
			fresh.forEach((el) => seen.add(el));
			callback(fresh);
		}
	};

	// Initial pass and handle Convert changes.
	run();
	window.addEventListener('convertChanged', run);
};

const convertQuerySelectorAll = (target: string, callback: (elements: Element[]) => void) => {
	convertQuerySelector(target, callback, true);
};

export { clickToCopy, setScrollBarWidth, convertQuerySelector, convertQuerySelectorAll };
